module.exports = __webpack_public_path__ + "img/preview-next-xl.f0f758da.svg";